module.exports = __webpack_public_path__ + "img/ternopil.34874055.png";